exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.data-rule-invalid{\n  background: #f4f4f4;\n  color: #bababa;\n}\n", ""]);

// exports
